// DS1.9
import React from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import BasicUserLink from '../_partials/BasicUserLink/BasicUserLink';
import BasicUserAvatar from '../_partials/BasicUserAvatar';
import s from './UserAvatar.scss';
function isClick(data) {
    var _data;
    return !((_data = data) === null || _data === void 0 ? void 0 : _data.evid) || data.evid === 101;
}
export const UserAvatar = ({ user, size, withLink = true, className, avatarClassName, biData, 'aria-hidden': ariaHidden, onTouchEnd, tabIndex, enableLazyLoad })=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "UserAvatar"
    }, withLink && user ? /*#__PURE__*/ React.createElement(BasicUserLink, {
        user: user,
        className: classnames(s['user-avatar'], className),
        biData: isClick(biData) ? biData : undefined,
        "aria-hidden": ariaHidden,
        onTouchEnd: onTouchEnd,
        tabIndex: tabIndex
    }, /*#__PURE__*/ React.createElement(BasicUserAvatar, {
        size: size,
        className: avatarClassName,
        user: user,
        "aria-hidden": ariaHidden,
        enableLazyLoad: enableLazyLoad
    })) : /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['user-avatar'], className)
    }, /*#__PURE__*/ React.createElement(BasicUserAvatar, {
        size: size,
        user: user,
        className: avatarClassName,
        "aria-hidden": ariaHidden,
        enableLazyLoad: enableLazyLoad
    })));
UserAvatar.displayName = 'UserAvatar';
export default UserAvatar;
